'use client';

export default function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#00A19B] focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none"
    >
      Saltar al contenido principal
    </a>
  );
}
